<template>
  <div class="feixe_gaus" style="display:none;">
    <div class="row">
      <h5 class="disparador" data-disparador="conteudo_feixe_gaus">
        Propriedades de Gaus
        <i class="material-icons">arrow_drop_down</i>
      </h5>
    </div>
    <div class="conteudo" id="conteudo_feixe_gaus">
      <div class="form-group">
        <label for="exampleInputEmail1">ω0</label>
        <input
          type="number"
          class="form-control"
          id="exampleInputEmail1"
          aria-describedby="emailHelp"
          placeholder
        />
        <small id="emailHelp" class="form-text text-muted">Confirmar o símbolo.</small>
      </div>
      <div class="form-group">
        <label for="exampleInputEmail1">ς0</label>
        <input
          type="number"
          class="form-control"
          id="exampleInputEmail1"
          aria-describedby="emailHelp"
          placeholder
        />
        <small id="emailHelp" class="form-text text-muted">Confirmar o símbolo.</small>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "feixeGauss"
};
</script>